(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-h-produkty"] && !Shopify.designMode) return;
  try {
    
  if (!window.serumDodajInit) {
    window.serumDodajInit = true;
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-serum-dodaj]');
      if (!btn) return;
      e.preventDefault();
      btn.classList.add('is-laduje');
      const drawer = document.querySelector('cart-drawer');
      let sekcje = [];
      try { if (drawer && typeof drawer.getSectionsToRender === 'function') sekcje = drawer.getSectionsToRender().map((x) => x.id); } catch (err) {}
      try {
        const odp = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.serumDodaj, 10), quantity: 1 }], sections: sekcje, sections_url: window.location.pathname })
        });
        const dane = await odp.json();
        if (!odp.ok || dane.status) throw new Error(dane.description || 'Błąd');
        if (drawer && typeof drawer.renderContents === 'function' && dane.sections) {
          drawer.classList.remove('is-empty');
          const stan = dane.items && dane.items[0] ? Object.assign({}, dane.items[0], { sections: dane.sections }) : dane;
          drawer.renderContents(stan);
        } else {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }
      } catch (err) {
        window.location.href = btn.dataset.url || '/cart';
      } finally {
        btn.classList.remove('is-laduje');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-komentarze-fb"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-karuzela')) {
    customElements.define('serum-karuzela', class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('[data-track]');
        if (!t) return;
        const p = this.querySelector('[data-prev]');
        const n = this.querySelector('[data-next]');
        const c = this.querySelector('[data-current]');
        const bar = this.querySelector('[data-progress]');
        const krok = () => {
          const a = t.children;
          if (a.length < 2) return t.clientWidth || 1;
          return (a[1].offsetLeft - a[0].offsetLeft) || t.clientWidth || 1;
        };
        const upd = () => {
          const max = t.scrollWidth - t.clientWidth;
          const i = Math.round(t.scrollLeft / krok());
          if (c) c.textContent = Math.min(i + 1, t.children.length);
          if (bar) bar.style.width = (max > 0 ? Math.max(10, (t.scrollLeft / max) * 100) : 100) + '%';
          if (p) p.disabled = t.scrollLeft <= 2;
          if (n) n.disabled = t.scrollLeft >= max - 2;
        };
        if (p) p.addEventListener('click', () => t.scrollBy({ left: -krok(), behavior: 'smooth' }));
        if (n) n.addEventListener('click', () => t.scrollBy({ left: krok(), behavior: 'smooth' }));
        t.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-opinie"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-karuzela')) {
    customElements.define('serum-karuzela', class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('[data-track]');
        if (!t) return;
        const p = this.querySelector('[data-prev]');
        const n = this.querySelector('[data-next]');
        const c = this.querySelector('[data-current]');
        const bar = this.querySelector('[data-progress]');
        const krok = () => {
          const a = t.children;
          if (a.length < 2) return t.clientWidth || 1;
          return (a[1].offsetLeft - a[0].offsetLeft) || t.clientWidth || 1;
        };
        const upd = () => {
          const max = t.scrollWidth - t.clientWidth;
          const i = Math.round(t.scrollLeft / krok());
          if (c) c.textContent = Math.min(i + 1, t.children.length);
          if (bar) bar.style.width = (max > 0 ? Math.max(10, (t.scrollLeft / max) * 100) : 100) + '%';
          if (p) p.disabled = t.scrollLeft <= 2;
          if (n) n.disabled = t.scrollLeft >= max - 2;
        };
        if (p) p.addEventListener('click', () => t.scrollBy({ left: -krok(), behavior: 'smooth' }));
        if (n) n.addEventListener('click', () => t.scrollBy({ left: krok(), behavior: 'smooth' }));
        t.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-produkt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-galeria')) {
    customElements.define('serum-galeria', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.thumbs = this.querySelector('[data-thumbs]');
        this.current = this.querySelector('[data-current]');
        this.mins = Array.from(this.querySelectorAll('.serum-galeria__min'));
        if (!this.track) return;
        this.mins.forEach((btn) => btn.addEventListener('click', () => this.idz(parseInt(btn.dataset.index, 10))));
        const prev = this.querySelector('[data-thumb-prev]');
        const next = this.querySelector('[data-thumb-next]');
        if (prev) prev.addEventListener('click', () => this.idz(Math.max(0, this.indeks() - 1)));
        if (next) next.addEventListener('click', () => this.idz(Math.min(this.mins.length - 1, this.indeks() + 1)));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.t);
          this.t = setTimeout(() => this.odswiez(), 60);
        }, { passive: true });
        this.odswiez();
      }
      indeks() {
        const w = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / w);
      }
      idz(i) {
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      }
      odswiez() {
        const i = this.indeks();
        if (this.current) this.current.textContent = i + 1;
        this.mins.forEach((b, n) => b.classList.toggle('is-active', n === i));
        const akt = this.mins[i];
        if (akt && this.thumbs) {
          const li = akt.parentElement;
          const l = li.offsetLeft - (this.thumbs.clientWidth - li.offsetWidth) / 2;
          this.thumbs.scrollTo({ left: l, behavior: 'smooth' });
        }
      }
    });
  }

  if (!customElements.get('serum-licznik')) {
    customElements.define('serum-licznik', class extends HTMLElement {
      connectedCallback() {
        this.pole = this.querySelector('[data-czas]');
        if (!this.pole) return;
        const min = parseInt(this.dataset.minuty, 10) || 30;
        const klucz = this.dataset.klucz;
        let koniec = 0;
        try { koniec = parseInt(sessionStorage.getItem(klucz), 10) || 0; } catch (e) {}
        const teraz = Date.now();
        if (!koniec || koniec <= teraz) {
          koniec = teraz + min * 60000;
          try { sessionStorage.setItem(klucz, koniec); } catch (e) {}
        }
        this.koniec = koniec;
        this.min = min;
        this.klucz = klucz;
        this.tick();
        this.iv = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.iv); }
      tick() {
        let reszta = Math.round((this.koniec - Date.now()) / 1000);
        if (reszta <= 0) {
          this.koniec = Date.now() + this.min * 60000;
          try { sessionStorage.setItem(this.klucz, this.koniec); } catch (e) {}
          reszta = this.min * 60;
        }
        const m = Math.floor(reszta / 60);
        const s = reszta % 60;
        this.pole.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-skladniki"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-karuzela')) {
    customElements.define('serum-karuzela', class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('[data-track]');
        if (!t) return;
        const p = this.querySelector('[data-prev]');
        const n = this.querySelector('[data-next]');
        const c = this.querySelector('[data-current]');
        const bar = this.querySelector('[data-progress]');
        const krok = () => {
          const a = t.children;
          if (a.length < 2) return t.clientWidth || 1;
          return (a[1].offsetLeft - a[0].offsetLeft) || t.clientWidth || 1;
        };
        const upd = () => {
          const max = t.scrollWidth - t.clientWidth;
          const i = Math.round(t.scrollLeft / krok());
          if (c) c.textContent = Math.min(i + 1, t.children.length);
          if (bar) bar.style.width = (max > 0 ? Math.max(10, (t.scrollLeft / max) * 100) : 100) + '%';
          if (p) p.disabled = t.scrollLeft <= 2;
          if (n) n.disabled = t.scrollLeft >= max - 2;
        };
        if (p) p.addEventListener('click', () => t.scrollBy({ left: -krok(), behavior: 'smooth' }));
        if (n) n.addEventListener('click', () => t.scrollBy({ left: krok(), behavior: 'smooth' }));
        t.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.serum-skl [data-flip]');
    if (!b) return;
    const k = b.closest('.serum-skl__karta');
    if (k) k.classList.toggle('is-odwrocona');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-statystyki"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-statystyki')) {
    customElements.define('serum-statystyki', class extends HTMLElement {
      connectedCallback() {
        const paski = this.querySelectorAll('[data-cel]');
        const start = () => paski.forEach((p) => { p.style.width = p.dataset.cel + '%'; });
        if (!('IntersectionObserver' in window)) { start(); return; }
        const io = new IntersectionObserver((w) => {
          if (w.some((x) => x.isIntersecting)) { start(); io.disconnect(); }
        }, { threshold: 0.3 });
        io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-transformacje"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-karuzela')) {
    customElements.define('serum-karuzela', class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('[data-track]');
        if (!t) return;
        const p = this.querySelector('[data-prev]');
        const n = this.querySelector('[data-next]');
        const c = this.querySelector('[data-current]');
        const bar = this.querySelector('[data-progress]');
        const krok = () => {
          const a = t.children;
          if (a.length < 2) return t.clientWidth || 1;
          return (a[1].offsetLeft - a[0].offsetLeft) || t.clientWidth || 1;
        };
        const upd = () => {
          const max = t.scrollWidth - t.clientWidth;
          const i = Math.round(t.scrollLeft / krok());
          if (c) c.textContent = Math.min(i + 1, t.children.length);
          if (bar) bar.style.width = (max > 0 ? Math.max(10, (t.scrollLeft / max) * 100) : 100) + '%';
          if (p) p.disabled = t.scrollLeft <= 2;
          if (n) n.disabled = t.scrollLeft >= max - 2;
        };
        if (p) p.addEventListener('click', () => t.scrollBy({ left: -krok(), behavior: 'smooth' }));
        if (n) n.addEventListener('click', () => t.scrollBy({ left: krok(), behavior: 'smooth' }));
        t.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-wideo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-wideo-karty')) {
    customElements.define('serum-wideo-karty', class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('[data-track]');
        const p = this.querySelector('[data-prev]');
        const n = this.querySelector('[data-next]');
        if (!t) return;
        const krok = () => { const k = t.querySelector('[data-karta]'); return k ? k.offsetWidth + 12 : 150; };
        const upd = () => {
          const max = t.scrollWidth - t.clientWidth;
          if (p) p.disabled = t.scrollLeft <= 2;
          if (n) n.disabled = t.scrollLeft >= max - 2;
        };
        if (p) p.addEventListener('click', () => t.scrollBy({ left: -krok(), behavior: 'smooth' }));
        if (n) n.addEventListener('click', () => t.scrollBy({ left: krok(), behavior: 'smooth' }));
        t.addEventListener('scroll', upd, { passive: true });
        upd();
        this.querySelectorAll('[data-karta]').forEach((k) => {
          k.addEventListener('click', () => {
            const tpl = k.querySelector('template[data-wideo]');
            if (tpl) this.otworz(tpl);
          });
        });
      }
      otworz(tpl) {
        const kolor = getComputedStyle(this.closest('.serum-wideo')).getPropertyValue('--sw-accent');
        const ov = document.createElement('div');
        ov.className = 'serum-wideo-modal';
        ov.style.setProperty('--sw-accent', kolor);
        ov.innerHTML = '<div class="serum-wideo-modal__box"><button type="button" class="serum-wideo-modal__x" aria-label="Zamknij"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></div>';
        ov.firstChild.appendChild(tpl.content.cloneNode(true));
        const zamknij = () => { ov.remove(); document.body.classList.remove('serum-bez-scrolla'); document.removeEventListener('keydown', esc); };
        const esc = (e) => { if (e.key === 'Escape') zamknij(); };
        ov.addEventListener('click', (e) => { if (e.target === ov || e.target.closest('.serum-wideo-modal__x')) zamknij(); });
        document.addEventListener('keydown', esc);
        document.body.appendChild(ov);
        document.body.classList.add('serum-bez-scrolla');
        const v = ov.querySelector('video');
        if (v) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-zaufanie"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serum-zaufanie-slider')) {
    customElements.define('serum-zaufanie-slider', class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('[data-track]');
        const kropki = Array.from(this.querySelectorAll('.serum-zauf__kropka'));
        if (!t || !kropki.length) return;
        const akt = () => {
          const i = Math.round(t.scrollLeft / (t.clientWidth || 1));
          kropki.forEach((k, n) => k.classList.toggle('is-active', n === i));
          return i;
        };
        kropki.forEach((k) => k.addEventListener('click', () => {
          t.scrollTo({ left: parseInt(k.dataset.i, 10) * t.clientWidth, behavior: 'smooth' });
          this.reset();
        }));
        t.addEventListener('scroll', () => { clearTimeout(this.tm); this.tm = setTimeout(akt, 60); }, { passive: true });
        this.reset = () => {
          clearInterval(this.iv);
          this.iv = setInterval(() => {
            if (window.matchMedia('(min-width: 990px)').matches) return;
            const nast = (akt() + 1) % kropki.length;
            t.scrollTo({ left: nast * t.clientWidth, behavior: 'smooth' });
          }, 4000);
        };
        this.reset();
      }
      disconnectedCallback() { clearInterval(this.iv); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
